import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
  IconButton,
  TablePagination,
  Menu,
  MenuItem,
  Box,
  Modal,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
} from "@mui/material";
import DefaultImage from "../../Assets/default_image.jpg";
import useHttp from "../../Hooks/use-http";
import { useHistory } from "react-router-dom";
import Loading from "../../Loading/Loading";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import PortalTitle from "../CommonComponent/PortalTitle";
import Button from "../CommonComponent/Button";
import Config from "../Settings/Config";
import SearchFilter from "../CommonComponent/SearchFilter";
import CustomInfoIcon from "../CommonComponent/CustomInfoIcon";
import CreateAdminModal from "./CreateAdminModal";
import SettingsIcon from "@mui/icons-material/Settings";
import { littleRed } from "../CommonComponent/DefineColors";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import CommonTablePagination from "../CommonComponent/CommonTablePagination";
import { useCalendarState } from "@mui/x-date-pickers/internals";
import { toast } from "react-toastify";
import { PAGINATIONBASEVALUE } from "../../Constant";

// const headers = [
//   "Corporate",
//   "Department",
//   "Address",
//   "Contract Date",
//   "Managers",
//   "Enable Modules",
//   //   "Admin",
//   "Action",
// ];
const headers = [
  { label: "Corporate", key: "name" },
  { label: "Department", key: "department" },
  { label: "Address", key: "address" },
  { label: "Contract Date", key: "contractDate" },
  { label: "Manager", key: "adminManager" },
  { label: "Enable Modules", key: "enableModules" },
  { label: "Action", key: "action" },
];

const headerWidths = {
  Corporate: "15%",
  Department: "20%",
  Address: "20%",
  "Contract Date": "10%",
  "Account Manager": "15%",
  "Enable Modules": "13%",
  // "Admin": "6%",
  Action: "7%",
};

// Helper function for stable sorting
function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  const valueA = getOrderValue(a, orderBy);
  const valueB = getOrderValue(b, orderBy);

  if (valueB < valueA) {
    return -1;
  }
  if (valueB > valueA) {
    return 1;
  }
  return 0;
}

function ascendingComparator(a, b, orderBy) {
  const valueA = getOrderValue(a, orderBy);
  const valueB = getOrderValue(b, orderBy);

  if (valueA < valueB) {
    return -1;
  }
  if (valueA > valueB) {
    return 1;
  }
  return 0;
}

function getOrderValue(item, orderBy) {
  switch (orderBy) {
    case "Corporate":
      return `${item.Name} ${item.CorporateLogo} ${item.CorporateID}`;
    // Add cases for other columns if needed
    case "Contract Date":
      return `${item.ContractStartDate} ${item.ContractEndDate}`;

    case "Managers":
      return `${item.AccountManagerID} ${item.SalesExecutive} ${item.InvoiceContactEmail} ${item.InvoiceContactName}`;
    default:
      return item[orderBy] || ""; // Default to empty string
  }
}

const CorporateRecords = () => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("Corporate ID");
  const [corporateData, setCorporateData] = useState([]);
  // const [loading, setLoading] = useState(true);
  const { sendRequest, isLoading } = useHttp();
  const history = useHistory();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(PAGINATIONBASEVALUE);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedCorporate, setSelectedCorporate] = useState(null);
  const [filteredData, setFilteredData] = useState(null);
  const [openConfigModal, setConfigModal] = useState(false);
  const [search, setSearch] = useState("");
  const [isCreateAdmin, setIsCreateAdmin] = useState(false);
  const [mainCorporate, setMainCorporate] = useState(null);
  const [isAddDeptOpen, setIsAddDeptOpen] = useState(false);
  const [newDeptName, setNewDeptName] = useState("");

  useEffect(() => {
    sendRequest(
      {
        // url: "/api/v1/Corporate/GetCorporates", // Updated URL
        url: "/corporates",
        method: "POST", // Updated method
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
          // roleID: localStorage.getItem("roleID"), // Assuming roleID is needed
          // corporateID: localStorage.getItem("corporateID"), // Assuming corporateID is needed
        },
      },
      corporateList // Assuming setCorporateData will update the corporate data state
    );
    // setLoading(false)
  }, [sendRequest]);

  const corporateList = (data) => {
    setCorporateData(data?.corporates || []);
    // setLoading(false);
  };

  useEffect(() => {
    setMainCorporate(corporateData?.filter((item) => item.parentID == null));
  }, [corporateData]);

  const handleSort = (column) => {
    if (orderBy === column && orderBy !== "" && order === "asc") {
      setOrder("desc");
    } else {
      setOrder("asc");
    }
    setOrderBy(column);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const sortedData = stableSort(
  //   corporateData,
  //   order === "asc"
  //     ? (a, b) => ascendingComparator(a, b, orderBy)
  //     : (a, b) => descendingComparator(a, b, orderBy)
  // );

  // const paginatedData = sortedData.slice(
  //   page * rowsPerPage,
  //   page * rowsPerPage + rowsPerPage
  // );
  // setFilteredData(paginatedData);
  useEffect(() => {
if(search && search.trim()){
  return ;
}


    const sortedData = stableSort(
      // corporateData,
      mainCorporate,
      order === "asc"
        ? (a, b) => ascendingComparator(a, b, orderBy)
        : (a, b) => descendingComparator(a, b, orderBy)
    );

    const paginatedData = sortedData?.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );

    setFilteredData(paginatedData);
  }, [mainCorporate, order, orderBy, page, rowsPerPage]);

  const handleMenuClick = (event, corporate) => {
    setAnchorEl(event.currentTarget);
    setSelectedCorporate(corporate);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    // setSelectedCorporate(null);
  };
  const handleOpenAddTaskModal = () => {
    setConfigModal(true);
  };

  const handleCloseAddTaskModal = () => {
    setConfigModal(false);
    // setSelectedCorporate([]);
  };

  const handleOpenCreateAdminClick = () => {
    setIsCreateAdmin(true);
  };
  const handleCloseCreateAdminClick = () => {
    setIsCreateAdmin(false);
  };

  const handleConfigClick = () => {
    // history.push({
    //   pathname: "/settings",
    //   state: { data: selectedCorporate },
    // });
    handleOpenAddTaskModal();
    handleMenuClose();
  };
  const handleAddPricingClick = () => {
    history.push({
      pathname: "/addpricing",
      state: { data: selectedCorporate },
    });
  };
  const handleCreateAdminClick = () => {
    handleOpenCreateAdminClick();
    handleMenuClose();
  };

  const handleSettingClick = () => {
    history.push({
      pathname: "/settings",
      state: { data: selectedCorporate },
    });
  };

  const handleCorporateDocumentClick = () => {
    history.push({
      pathname: "/corporatedocument",
      state: { data: selectedCorporate },
    });
  };

  const handleAddDepartment = (item) => {
    // setSelectedCorporate(item); // you can send this with API if needed
    setIsAddDeptOpen(true);
    setAnchorEl(null);
  };

  const renderAdmins = (admins) => {
    if (!admins) return "-";
    const adminList = admins.split(", ");
    if (adminList.length === 1) return adminList?.[0];

    const firstAdmin = adminList?.[0];
    const otherAdmins = adminList;

    return (
      <div>
        {firstAdmin}
        <CustomInfoIcon
          message={
            <div style={{ paddingLeft: "16px" }}>
              <ol>
                {otherAdmins?.map((admin, index) => (
                  <li key={index}>{admin}</li>
                ))}
              </ol>
            </div>
          }
        />
      </div>
    );
  };

  const handleAddDepartmentSubmitButton = () => {
    sendRequest(
      {
        url: "/adddepartment",
        method: "POST", // Updated method
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
          data: {
            parentID: selectedCorporate.corporateID,

            newDepartment: newDeptName,
          },
        },
      },
      newDepartmentCorporate // Assuming setCorporateData will update the corporate data state
    );
  };
  const newDepartmentCorporate = (data) => {
    if (data.status === 200 || data.status === 201) {
      toast.success(data.message);
      setIsAddDeptOpen(false);
    } else {
      toast.error(data.message);
    }
  };

  return (
    <React.Fragment>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Paper
          sx={{
            width: "100%",
            mb: 2,
            borderRadius: "10px",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            border: "none",
            borderBottom: "none",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 2,
              pt: 1,
              pb: 1,
              borderRadius: "10px",
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 1, md: 0 },
            }}
          >
            <Box component="h2" sx={{ m: 0, display: "flex", alignItems: "center" }}>
              <PortalTitle fallback="corporates" />
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: "12px",
                alignItems: "center",
                flexDirection: { xs: "column", md: "row" },
            }}
          >
            <SearchFilter
              data={mainCorporate || []}
              setSearchValue={setSearch}
              searchValue={search}
              setFilteredData={setFilteredData}
            />
              <Button
                label="Add Corporate"
                onClick={() => history.push("/new-registration")}
                variant="contained"
                size="medium"
                sx={{
                  backgroundColor: "#44B150",
                  ":hover": {
                    backgroundColor: "#44B150",
                    opacity: 0.8,
                  },
                  boxShadow: "none",
                  fontFamily: "Montserrat",
                  fontSize: "12px",
                  padding: "8px 20px",
                  textTransform: "none",
                  minWidth: "110px",
                  marginLeft: "12px",
                }}
              />
            </Box>
          </Box>
          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              margin: "auto",
              borderRadius: "10px",
              boxShadow: "none",
              border: "none",
              borderBottom: "none",
              "& .MuiPaper-root": {
                border: "none",
                borderBottom: "none",
              },
            }}
          >
            <Table
              sx={{
                fontFamily: "Montserrat",
              }}
              size="medium"
            >
              <TableHead>
                <TableRow>
                  {headers?.map((header) => (
                    <TableCell
                      key={header.key}
                      align="center"
                      sx={{
                        py: 1,
                        px: 2,
                        fontWeight: 600,
                        fontSize: "0.875rem",
                        color: "rgba(0, 0, 0, 0.87)",
                        width: headerWidths[header.label],
                      }}
                    >
                      <TableSortLabel
                        active={true}
                        direction={orderBy === header.key ? order : "asc"}
                        onClick={() => handleSort(header.key)}
                        sx={{ fontSize: "0.875rem" }}
                      >
                        {header.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={headers?.length + 1}>
                      <Loading datatable="true" />
                    </TableCell>
                  </TableRow>
                ) : filteredData?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={headers?.length + 1}>
                      <div style={{ textAlign: "center", marginTop: "10px" }}>
                        No Data Available
                      </div>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredData?.map((item, index) => (
                    <React.Fragment key={index}>
                      <TableRow key={index}>
                        <TableCell
                          align="center"
                          sx={{ fontSize: "0.875rem", py: 1, px: 2 }}
                        >
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              alignItems: "center",
                            }}
                          >
                            <div>
                              <img
                                src={item.imageID ? item.imageID : DefaultImage}
                                alt="Admin"
                                style={{ width: "50px", height: "50px" }}
                              />
                            </div>

                            <div>
                              {item.name} <br />
                              <span style={{ fontSize: "10px" }}>
                                {" "}
                                ({item.corporateID
                                  ? item.corporateID
                                  : "-"}){" "}
                              </span>
                            </div>
                          </div>
                        </TableCell>

                        <TableCell
                          align="center"
                          sx={{ fontSize: "0.875rem", py: 1, px: 2 }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ display: "flex", gap: "2px" }}>
                              <div>{1}.</div>
                              <div>
                                <div>{item.departments?.[0]?.name}</div>
                                <div style={{ fontSize: "10px" }}>
                                  ({item.departments?.[0]?.corporateID})
                                </div>
                              </div>
                            </div>
                            {item.departments?.length > 1 && (
                              <CustomInfoIcon
                                style={{ margin: "auto" }}
                                message={item.departments?.map((dep, index) => (
                                  <div key={dep?.corporateID || Math.random()}>
                                    <div
                                      style={{ display: "flex", gap: "2px" }}
                                    >
                                      <div>{index + 1}.</div>
                                      <div>
                                        <div>{dep?.name ? dep?.name : "-"}</div>
                                        <div style={{ fontSize: "10px" }}>
                                          (
                                          {dep?.corporateID
                                            ? dep?.corporateID
                                            : "-"}
                                          )
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              />
                            )}
                          </div>
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ fontSize: "0.875rem", py: 1, px: 2 }}
                        >
                          {item?.address && item?.corporateLatlong ? (
                            <a
                              href={`https://www.google.com/maps?q=${item.corporateLatlong}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                                color: "blue",
                              }}
                            >
                              {item?.address}
                            </a>
                          ) : (
                            item?.address || "-"
                          )}
                        </TableCell>

                        {/* <TableCell sx={{ fontSize: "0.8rem", p: 1 }}>
                        
                      {item.Address ? item.Address : "-"}
                    </TableCell> */}
                        <TableCell
                          align="center"
                          sx={{ fontSize: "0.875rem", py: 1, px: 2 }}
                        >
                          <div
                            style={{ alignItems: "center", marginLeft: "8px" }}
                          >
                            {item.contractStartDate
                              ? item.contractStartDate
                              : "-"}
                          </div>
                          <div
                            style={{ alignItems: "center", marginLeft: "8px" }}
                          >
                            to
                          </div>
                          <div
                            style={{ alignItems: "center", marginLeft: "8px" }}
                          >
                            {item.contractEndDate ? item.contractEndDate : "-"}
                          </div>
                          {/* {" "}to {" "}  */}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ fontSize: "0.875rem", py: 1, px: 2 }}
                        >
                          <strong>Account:</strong>{" "}
                          {item?.AccountManagerID
                            ? item?.AccountManagerID?.EmpName
                            : "-"}
                          <br />
                          <strong>Sales:</strong>{" "}
                          {item.SalesExecutive
                            ? item?.SalesExecutive?.EmpName
                            : "-"}{" "}
                          <br />
                          <div>
                            <strong>Admin:</strong>{" "}
                            {item.Admins ? renderAdmins(item.Admins) : "-"}
                            <br />
                          </div>
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ fontSize: "0.875rem", py: 1, px: 2 }}
                        >
                          {item?.enabledModule ? item?.enabledModule : "-"}
                        </TableCell>

                        <TableCell>
                          <IconButton
                            onClick={(event) => handleMenuClick(event, item)}
                          >
                            <MoreVertIcon />
                          </IconButton>
                          <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                            sx={{
                              "& .MuiPaper-root": {
                                boxShadow: "none",
                                borderRadius: "10px",
                                border: "1px solid #ccc",
                              },
                            }}
                          >
                            {/* <MenuItem onClick={handleConfigClick}>
                        
                          Configuration
                        </MenuItem> */}
                            <MenuItem onClick={handleConfigClick}>
                              <ListItemIcon>
                                <SettingsIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText>Configuration</ListItemText>
                            </MenuItem>
                            {/* <MenuItem onClick={handleAddPricingClick}>
                          Pricing Structure
                        </MenuItem> */}
                            <MenuItem onClick={handleAddPricingClick}>
                              <ListItemIcon>
                                <AttachMoneyIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText>Pricing Structure</ListItemText>
                            </MenuItem>
                            {/* <MenuItem onClick={handleSettingClick}>Tasks</MenuItem> */}
                            <MenuItem onClick={handleSettingClick}>
                              <ListItemIcon>
                                <AssignmentIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText>Tasks</ListItemText>
                            </MenuItem>
                            {/* <MenuItem onClick={handleCreateAdminClick}>
                          Create Admin
                        </MenuItem> */}
                            <MenuItem onClick={handleCreateAdminClick}>
                              <ListItemIcon>
                                <PersonAddIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText>Create Admin</ListItemText>
                            </MenuItem>

                            {/* corporateDocumnet */}
                            <MenuItem onClick={handleCorporateDocumentClick}>
                              <ListItemIcon>
                                <AssignmentIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText>Document</ListItemText>
                            </MenuItem>

                            {/* addDepartment */}
                            <MenuItem onClick={() => handleAddDepartment(item)}>
                              <ListItemIcon>
                                <AssignmentIcon fontSize="small" />
                              </ListItemIcon>
                              <ListItemText>Add Department</ListItemText>
                            </MenuItem>
                          </Menu>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Box
            sx={{
              position: "sticky",
              bottom: 0,
              background: "white",
              zIndex: 1,
              border: "none !important",
              borderTop: "none !important",
              borderBottom: "none !important",
              "&::before": {
                display: "none",
              },
              "&::after": {
                display: "none",
              },
            }}
          >
            <CommonTablePagination
              page={page}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              setPage={setPage}
              filteredData={filteredData}
              styling={{
                display: "flex",
                justifyContent: "flex-end",
                border: "none",
                borderTop: "none",
                borderBottom: "none",
                "& .MuiTablePagination-root": {
                  border: "none",
                  borderTop: "none",
                  borderBottom: "none",
                  "&::before": {
                    display: "none",
                  },
                  "&::after": {
                    display: "none",
                  },
                },
                "& .MuiTablePagination-toolbar": {
                  border: "none",
                  borderTop: "none",
                  borderBottom: "none",
                  "&::before": {
                    display: "none",
                  },
                  "&::after": {
                    display: "none",
                  },
                },
                "& .MuiTablePagination-spacer": {
                  border: "none",
                },
              }}
            />
          </Box>
        </Paper>
      </Box>

      {/* Configuration----------- */}
      <Modal
        open={openConfigModal}
        // onClose={handleCloseAddTaskModal}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleCloseAddTaskModal();
          }
        }}
        aria-labelledby="add-new-task-modal"
        aria-describedby="add-new-task-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            overflowX: "hidden",
            transform: "translate(-50%, -50%)",
            width: "70%",
            maxHeight: "80vh",
            overflowY: "auto",
            bgcolor: "background.paper",
            // bgcolor: "rgba(34, 137, 203, 255)",
            // border: "2px solid",
            zIndex: "1500",
            boxShadow: 24,
            borderRadius: 4,
            p: 3,
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
            }}
          >
            <IconButton
              onClick={handleCloseAddTaskModal}
              sx={{
                color: littleRed,
                "&:hover": {
                  backgroundColor: "rgba(213, 32, 41, 0.1)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
            {/* <IconButton  onClick={handleCloseAddTaskModal}>
              <Cross style={{ width: 50, height: 50 }} />
              x
            </IconButton> */}
          </Box>
          <Config
            corporateData={selectedCorporate && selectedCorporate}
            setCorporateData={setCorporateData}
            // getTaskList={getTaskList}
            onCloseModal={handleCloseAddTaskModal}
          />
        </Box>
      </Modal>

      {/* Create Admin------------- */}
      <Modal
        open={isCreateAdmin}
        // onClose={handleCloseAddTaskModal}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleCloseCreateAdminClick();
          }
        }}
        aria-labelledby="add-new-task-modal"
        aria-describedby="add-new-task-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            overflowX: "hidden",
            transform: "translate(-50%, -50%)",
            width: "60%",
            maxHeight: "95vh",
            overflowY: "auto",
            bgcolor: "background.paper",
            // bgcolor: "rgba(34, 137, 203, 255)",
            // border: "2px solid",
            zIndex: "1500",
            boxShadow: 24,
            borderRadius: 4,
            p: 3,
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
            }}
          >
            <Button
              // variant="contained"
              // color="white"
              onClick={handleCloseCreateAdminClick}
              sx={{ fontSize: "20px", color: "white" }}
            >
              x
            </Button>
            {/* <IconButton  onClick={handleCloseAddTaskModal}>
              <Cross style={{ width: 50, height: 50 }} />
              x
            </IconButton> */}
          </Box>
          <CreateAdminModal
            corporateData={selectedCorporate && selectedCorporate}
            setCorporateData={setCorporateData}
            // getTaskList={getTaskList}
            onCloseModal={handleCloseCreateAdminClick}
          />
        </Box>
      </Modal>

      {/* Modal for add department */}
      <Dialog
        open={isAddDeptOpen}
        onClose={() => setIsAddDeptOpen(false)}
        fullWidth
        maxWidth="sm"
        disableEscapeKeyDown
        onBackdropClick={(e) => e.stopPropagation()}
      >
        <DialogTitle>Add New Department</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="New Department Name"
            variant="standard"
            fullWidth
            value={newDeptName}
            onChange={(e) => setNewDeptName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setIsAddDeptOpen(false)}
            sx={{
              backgroundColor: littleRed,
              color: "white",
              "&:hover": {
                backgroundColor: littleRed,
                opacity: 0.8,
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleAddDepartmentSubmitButton}
            variant="contained"
            color="success"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default CorporateRecords;
